import { render } from "./pageAchieve.vue?vue&type=template&id=5ad27d68&scoped=true"
import script from "./pageAchieve.vue?vue&type=script&lang=js"
export * from "./pageAchieve.vue?vue&type=script&lang=js"

import "./pageAchieve.vue?vue&type=style&index=0&id=5ad27d68&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad27d68"]])

export default __exports__